import React, { useEffect, useRef } from 'react';
import { NumericFormat } from 'react-number-format';

import { validationAndUpdateValue } from 'components/form-multi/utils';

import { COMMON_AMOUNT_ISSUE, MAX_AMOUNT_ISSUE, MIN_AMOUNT_ISSUE, MULTIPLE_AMOUNT_ISSUE } from 'constants/Constants';

import { inputPropType } from 'helpers/customPropTypes';
import { resolveArguments } from 'helpers/utils';

import PromoInputBase from './PromoInputBase';

const PromoInputAmount = (props) => {
    const firstRender = useRef(true);
    const hasError = useRef(false);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if (props.field.value && props.enabledValidateMinMaxAmount) {
            const value = props.field.value;
            validationAndUpdateValue(props.formName, value, props.field, props.changeFormField).then(() => {
                if (props.enabledValidateMinMaxAmount) {
                    validateMinMaxMultipleAmount(parseFloat(value ? value.replaceAll(' ', '') : value));
                }
            });
        }
    }, [props.minAmount, props.maxAmount]);

    const handlerChange = (value) => {
        if (props.googlePay) {
            let totalPriceObject = { value: value };
            window.localStorage.setItem('totalPrice', JSON.stringify(totalPriceObject));
        }

        validationAndUpdateValue(props.formName, value.value, props.field, props.changeFormField).then(() => {
            if (props.enabledValidateMinMaxAmount) {
                validateMinMaxMultipleAmount(value.floatValue);
            }
            if (props.onChangeHandler) {
                props.onChangeHandler(props.field.value, props.field.name);
            }
        });
    };

    const validateMinMaxMultipleAmount = (value) => {
        let errorCode = COMMON_AMOUNT_ISSUE;
        const min = props.minAmount;
        const max = props.maxAmount;
        const multiple = props.multiple;
        let errorMessage;
        if (value < min) {
            errorMessage = resolveArguments(props.jsMessages['site.js.validation.min.valid.error'], min);
            errorCode = MIN_AMOUNT_ISSUE;
        } else if (value > max) {
            errorMessage = resolveArguments(props.jsMessages['site.js.validation.max.valid.error'], max);
            errorCode = MAX_AMOUNT_ISSUE;
        } else if (multiple && value % multiple !== 0) {
            errorMessage = resolveArguments(props.jsMessages['site.js.validation.multiple.error'], multiple);
            errorCode = MULTIPLE_AMOUNT_ISSUE;
        }
        if (errorMessage) {
            props.setFieldError(props.formName, props.field.name, { body: errorMessage, code: errorCode });
        }
        hasError.current = !!errorMessage;
    };

    const handlerBlur = (e) => {
        const value = e.target.value;
        const field = props.field;

        if (!hasError.current) {
            validationAndUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
                callBlurHandler(field, value);
            });
        } else {
            callBlurHandler(field, value);
        }

        if (props.onBlur) {
            props.onBlur(e);
        }
    };

    const callBlurHandler = (field, value) => {
        if (props.onBlurHandler) {
            props.onBlurHandler(value, field.name, field.checkRegexp, field.mandatory);
        }
    };

    const handlerFocus = (e) => {
        if (props.onFocusHandler) {
            props.onFocusHandler(e);
        }

        if (props.onFocus) {
            props.onFocus(e);
        }
    };

    const field = props.field;
    if (field.value === null) {
        field.value = '';
    }
    const dataTestAttr = props.isLanding && props.isFrom ? '-from' : props.isLanding && !props.isFrom ? '-to' : '';
    return (
        <NumericFormat
            id={field.name}
            maxLength="14"
            name={field.canonicalPath ? field.canonicalPath : field.name}
            value={field.value || ''}
            type={field.type}
            readOnly={props.readOnly}
            autoComplete="off"
            allowNegative={false}
            thousandSeparator={' '}
            fixedDecimalScale={true}
            data-testid={`input-amount-number${dataTestAttr}`}
            decimalScale={2}
            onValueChange={handlerChange}
            onBlur={handlerBlur}
            onFocus={handlerFocus}
        />
    );
};

PromoInputAmount.propTypes = inputPropType(['number', 'tel']);

export default PromoInputBase(PromoInputAmount, true);
